import React from "react";
import circle1 from "images/pattern/circle-1.svg";
import circle2 from "images/pattern/circle-2.svg";

const Circle = ({ variant = "one", className }) => {
  return variant === "one" ? (
    <div className="absolute bottom-0 right-0 z-0 overflow-hidden">
      <img src={circle1} alt={"circle1"} />
    </div>
  ) : variant === "two" ? (
    <div className={className}>
      <img src={circle2} alt={"circle2"} />
    </div>
  ) : (
    ""
  );
};

export default Circle;
